/*
On the IOS app we append a custom userAgent. This function searches for the custom part of the userAgent to determine if we are on the app.
 */

export function webViewFinder() {
  const userAgent = window.navigator.userAgent;
  return /abartysPatientlynk/.test(userAgent);
}
